import { Box, Grid, Typography } from "@mui/material";

const ContactUsBlock = () => {
  return (
    <>
      <Box sx={{ textAlign: "center", marginBottom: 4 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          mb={0}
          sx={{ fontWeight: "bold" }}
        >
          Contact Us
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Have a Question or Concern? Contact Us and We’ll Help You Through!
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Typography variant="body1" paragraph sx={{ textAlign: "left" }}>
            Thank you for stopping by our website. Our dedicated and hardworking
            team is here to manage your mail, handle your calls, and provide
            behind-the-scenes support for your business. We guarantee
            professional, dependable, and friendly service at all times.
          </Typography>
          <Typography variant="body1" paragraph sx={{ textAlign: "left" }}>
            Our support team is available to assist you from 9:00 AM to 5:30 PM,
            Monday through Friday, except on UK public holidays.
          </Typography>
          <Typography variant="body1" paragraph sx={{ textAlign: "left" }}>
            To get in touch, kindly use our contact form to send an email, or
            find our details below to give us a call or schedule a call back.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <img
            style={{ "max-width": "100%", height: "auto" }}
            src={`${process.env.PUBLIC_URL}/images/contact_us.jpg`}
            alt="Contact Us"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ContactUsBlock;
